import '@mdi/font/css/materialdesignicons.css'

import 'vuetify/styles'
// import '../assets/main.scss'

import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import { md3 } from 'vuetify/blueprints'

const LearningHubLightTheme = {
  dark: false,
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    primary: '#9756d6',
    'primary-darken-1': '#9756d6',
    secondary: '#aadcaa1a',
    'secondary-darken-1': '#aadcaa1a',
    error: '#f44336',
    info: '#ffe599',
    success: '#32b432',
    warning: '#ffdd00'
  }
}

const vuetify = createVuetify({
  components,
  directives,
  ssr: true,
  iconfont: 'mdi',
  blueprint: md3,
  theme: {
    defaultTheme: 'LearningHubLightTheme',
    themes: {
      LearningHubLightTheme
    }
  }
})

export default vuetify
